/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboundFaxResponseDto
 */
export interface InboundFaxResponseDto {
    /**
     * 
     * @type {string}
     * @memberof InboundFaxResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InboundFaxResponseDto
     */
    vendorFaxId: string;
    /**
     * 
     * @type {string}
     * @memberof InboundFaxResponseDto
     */
    fromNumber: string;
    /**
     * 
     * @type {string}
     * @memberof InboundFaxResponseDto
     */
    toNumber: string;
    /**
     * 
     * @type {number}
     * @memberof InboundFaxResponseDto
     */
    numberOfPages?: number;
    /**
     * 
     * @type {string}
     * @memberof InboundFaxResponseDto
     */
    status: InboundFaxResponseDtoStatusEnum;
    /**
     * 
     * @type {object}
     * @memberof InboundFaxResponseDto
     */
    patientId?: object | null;
    /**
     * 
     * @type {Date}
     * @memberof InboundFaxResponseDto
     */
    receivedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof InboundFaxResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof InboundFaxResponseDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const InboundFaxResponseDtoStatusEnum = {
    Received: 'received',
    Failed: 'failed'
} as const;
export type InboundFaxResponseDtoStatusEnum = typeof InboundFaxResponseDtoStatusEnum[keyof typeof InboundFaxResponseDtoStatusEnum];


/**
 * Check if a given object implements the InboundFaxResponseDto interface.
 */
export function instanceOfInboundFaxResponseDto(value: object): value is InboundFaxResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('vendorFaxId' in value) || value['vendorFaxId'] === undefined) return false;
    if (!('fromNumber' in value) || value['fromNumber'] === undefined) return false;
    if (!('toNumber' in value) || value['toNumber'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('receivedAt' in value) || value['receivedAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function InboundFaxResponseDtoFromJSON(json: any): InboundFaxResponseDto {
    return InboundFaxResponseDtoFromJSONTyped(json, false);
}

export function InboundFaxResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundFaxResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'vendorFaxId': json['vendorFaxId'],
        'fromNumber': json['fromNumber'],
        'toNumber': json['toNumber'],
        'numberOfPages': json['numberOfPages'] == null ? undefined : json['numberOfPages'],
        'status': json['status'],
        'patientId': json['patientId'] == null ? undefined : json['patientId'],
        'receivedAt': (new Date(json['receivedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function InboundFaxResponseDtoToJSON(json: any): InboundFaxResponseDto {
    return InboundFaxResponseDtoToJSONTyped(json, false);
}

export function InboundFaxResponseDtoToJSONTyped(value?: InboundFaxResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'vendorFaxId': value['vendorFaxId'],
        'fromNumber': value['fromNumber'],
        'toNumber': value['toNumber'],
        'numberOfPages': value['numberOfPages'],
        'status': value['status'],
        'patientId': value['patientId'],
        'receivedAt': ((value['receivedAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

